module.exports = __webpack_public_path__ + "media/images/flags/16/Armenia-0fab11110347997ec58487cf435e851f.png";